import type { SVGProps } from 'react';

const SvgStarBoldDecor = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M12 0.5C13.2 5.8 18.2 10.8 23.5 12C18.2 13.2 13.2 18.2 12 23.5C10.8 18.2 5.8 13.2 0.5 12C5.8 10.8 10.8 5.8 12 0.5Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgStarBoldDecor;
